import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"


import SpacedRow from '@shell/components/Resource/Detail/SpacedRow.vue';
import { computed } from 'vue';

export interface Props {
  resource: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Cards',
  props: {
    resource: {}
  },
  setup(__props: any) {


const cards = computed(() => __props.resource?.cards?.filter((c: any) => c) || []);

return (_ctx: any,_cache: any) => {
  return (cards.value.length > 0)
    ? (_openBlock(), _createBlock(SpacedRow, {
        key: 0,
        class: "resource-cards"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card, i) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(card.component), _mergeProps({ key: i }, { ref_for: true }, card.props), null, 16))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})